import { render } from "./UserView.vue?vue&type=template&id=0df4f258&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=0df4f258&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0df4f258"

export default script